import React, { Children, isValidElement } from "react";
import ScrollReveal from "./Reveal";
import Footer from "./Footer";
import SmallContact from "./SmallContact";

function shouldSkipAutoReveal(element) {
  if (!isValidElement(element)) return true;

  const props = element.props || {};

  if ("data-page-hero" in props || "data-reveal-managed" in props) {
    return true;
  }

  if (typeof element.type === "function" && element.type.revealManaged) {
    return true;
  }

  return false;
}

function PageShell({ children, reveal = true, className = "" }) {
  const childList = Children.toArray(children);
  const content = reveal
    ? childList.map((child, index) => {
        if (shouldSkipAutoReveal(child)) {
          return child;
        }

        const key =
          isValidElement(child) && child.key != null
            ? child.key
            : `page-reveal-${index}`;

        return <ScrollReveal key={key}>{child}</ScrollReveal>;
      })
    : childList;

  return (
    <>
      <main id="main-content" className={className || undefined}>
        {content}
      </main>
      <Footer />
      <SmallContact />
    </>
  );
}

export default PageShell;
